import Select from "react-select";
import { FormRule, field } from "../../types";
const OPERATORS: { value: FormRule["when"][number]["operator"]; label: string }[] = [
    { value: "eq", label: "=" },
    { value: "notEq", label: "≠" },
    { value: "gt", label: ">" },
    { value: "gte", label: "≥" },
    { value: "lt", label: "<" },
    { value: "lte", label: "≤" },
    { value: "bt", label: "between" }
];
export function RuleEditor({
    rule,
    fields,
    onChange,
    onRemove
}: {
    rule: FormRule;
    fields: field[];
    onChange: (patch: Partial<FormRule>) => void;
    onRemove: () => void;
}) {
    function updateCondition(index: number, patch: Partial<FormRule["when"][number]>) {
        const next = [...rule.when];
        next[index] = { ...next[index], ...patch };
        onChange({ when: next });
    }
    function addCondition() {
        onChange({
            when: [
                ...rule.when,
                {
                    field_key: -1,
                    operator: "eq",
                    value: ""
                }
            ]
        });
    }
    function removeCondition(index: number) {
        onChange({
            when: rule.when.filter((_, i) => i !== index)
        });
    }
    return (
        <div className = "border rounded p-2 mb-2 bg-light">
            <strong>Rule</strong>
            {rule.when.map((cond, i) => (
                <div
                    key = {i}
                    className = "d-flex gap-2 align-items-center flex-wrap mt-2"
                >
                    {i > 0 && <span className = "fw-bold">AND</span>}
                    <select
                        id = {i + " field_key"}
                        name = {i + " field_key"}
                        required
                        className = "form-control inline"
                        value = {cond.field_key}
                        onChange = {e =>
                            updateCondition(i, { field_key: Number(e.target.value)})
                        }
                    >
                        <option value = "">-- field --</option>
                        {fields.filter(field => field.label).map(field => (
                            <option key = {field.field_key} value = {field.field_key}>
                                {field.label || field.field_key}
                            </option>
                        ))}
                    </select>
                    <select
                        id = {i + " op"}
                        name = {i + " op"}
                        className = "form-control inline text-center"
                        value = {cond.operator}
                        onChange = {e =>
                            updateCondition(i, {
                                operator: e.target.value as any
                            })
                        }
                    >
                        {OPERATORS.map(op => (
                            <option key = {op.value} value = {op.value}>
                                {op.label}
                            </option>
                        ))}
                    </select>
                    {cond.operator === "bt" ? (
                        <>
                            <input
                                id = {i + " from"}
                                name = {i + " from"}
                                className = "form-control inline"
                                placeholder = "from"
                                value = {Array.isArray(cond.value) ? cond.value[0] : ""}
                                onChange = {e =>
                                    updateCondition(i, {
                                        value: [
                                            e.target.value,
                                            Array.isArray(cond.value)
                                                ? cond.value[1]
                                                : ""
                                        ]
                                    })
                                }
                            />
                            <input
                                id = {i + " to"}
                                name = {i + " to"}
                                className = "form-control inline"
                                placeholder = "to"
                                value = {Array.isArray(cond.value) ? cond.value[1] : ""}
                                onChange = {e =>
                                    updateCondition(i, {
                                        value: [
                                            Array.isArray(cond.value)
                                                ? cond.value[0]
                                                : "",
                                            e.target.value
                                        ]
                                    })
                                }
                            />
                        </>
                    ) : (
                        <input
                            id = {i + " value"}
                            name = {i + " value"}
                            className = "form-control inline"
                            placeholder = "value"
                            value = {typeof cond.value === "string" ? cond.value : ""}
                            onChange = {e =>
                                updateCondition(i, { value: e.target.value })
                            }
                        />
                    )}
                    <button
                        type = "button"
                        className = "btn btn-outline-danger"
                        onClick = {() => removeCondition(i)}
                    >
                        ✕
                    </button>
                </div>
            ))}
            <div className = "mt-2">
                <button
                    type = "button"
                    className = "btn btn-sm btn-primary"
                    onClick = {addCondition}
                >
                    + Add Condition
                </button>
            </div>
            <div className = "d-flex gap-2 mt-3 align-items-center flex-wrap">
                <strong>Then</strong>
                <label htmlFor = {rule.id + " show"}>Show</label>
                <Select
                    inputId = {rule.id + " show"}
                    isMulti
                    className = "inline"
                    placeholder = "fields…"
                    options = {(fields ?? []).map(field => ({label: field.label, value: field.field_key}))}
                    value = {
                        (rule.then.show ?? []).map(v => ({label: (fields ?? []).find(f => f.field_key === v)!.label, value: (fields ?? []).find(f => f.field_key === v)!.field_key}))}
                    onChange = {(selected) => {
                        onChange({
                            then: {
                                ...rule.then,
                                show: (selected.map(s => (s.value) ) ?? [])
                            }
                        });
                    }}
                />
                <button
                    type = "button"
                    className = "btn btn-outline-danger ms-auto"
                    onClick = {onRemove}
                >
                    Delete Rule
                </button>
            </div>
        </div>
    );
}
